<div class="modal-header">
    <h5 class="modal-title">Unsaved changes</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
        <span>&times;</span>
    </button>
</div>
<div class="modal-body unsaved-changes-dialog">
    You have unsaved changes. Are you sure you want to leave this page?
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="activeModal.close()">Leave this page</button>
    <button type="button" class="btn btn-primary" (click)="activeModal.dismiss()">Stay on Page</button>
</div>